import React from 'react';
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import NotFound from './page/pages/NotFound';
import Page403 from './page/pages/403';
import Page500 from './page/pages/500';
import Login from './page/pages/Login';
import MerchantLogin from './page/pages/MerchantLogin';
import Agreement from './page/Agreement';
import ModifyPassword from './page/pages/ModifyPassword';
import MerchantModifyPassword from './page/pages/MerchantModifyPassword';
import App from './App';

export default () => (
    <Router>
        <Switch>
            <Route exact path="/" render={() => <Redirect to="/admin/rentContract/expireList" push />} />
            <Route path="/admin" component={App} />
            <Route path="/mini" component={App} />
            <Route path="/404" component={NotFound} />
            <Route path="/403" component={Page403} />
            <Route path="/500" component={Page500} />
            <Route path="/login" component={Login} />
            <Route path="/merchantLogin" component={MerchantLogin} />
            <Route path="/agreement" component={Agreement} />
            <Route path="/modifyPassword" component={ModifyPassword} />
            <Route path="/merchantModifyPassword" component={MerchantModifyPassword} />
            <Route component={NotFound} />
        </Switch>
    </Router>
)


// WEBPACK FOOTER //
// ./src/Page.js